function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.234 21.636L30 9.36 26.752 6 15 18.262 3.248 6 0 9.36l11.766 12.276-.004.004.808.835L14.99 25l.01-.01.01.01 2.42-2.525.808-.835-.004-.004z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "6",
  width: "30",
  height: "19"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.234 21.636L30 9.36 26.752 6 15 18.262 3.248 6 0 9.36l11.766 12.276-.004.004.808.835L14.99 25l.01-.01.01.01 2.42-2.525.808-.835-.004-.004z",
  fill: "currentColor"
}))));